import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { environment } from "../environments/environment";
import { loadData, loadDataError, loadDataSuccess } from "./store.action";


@Injectable()
export class DataEffects {
  constructor(private actions$: Actions, private http: HttpClient) {}

  loadData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadData),
      switchMap(() =>
        this.http.get(`${environment.apiUrl}drivers`).pipe(
          map((data) => loadDataSuccess({ data })),
          catchError((error) => of (loadDataError(error)))
        )
      )
    )
  );
}
